import { render } from "./BrushThickness.vue?vue&type=template&id=541249d4&scoped=true&ts=true"
import script from "./BrushThickness.vue?vue&type=script&lang=ts"
export * from "./BrushThickness.vue?vue&type=script&lang=ts"

import "./BrushThickness.vue?vue&type=style&index=0&id=541249d4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541249d4"]])

export default __exports__